// extracted by mini-css-extract-plugin
module.exports = {"status":"status_status__3EJ4r","new":"status_new__iv02D","completed":"status_completed__2riJl","InProgress":"status_InProgress__3Jn66"};